import _objectSpread from "/Users/juji/works/test/react-jimage-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _toConsumableArray from "/Users/juji/works/test/react-jimage-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/juji/works/test/react-jimage-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useSpring, animated, useTransition } from 'react-spring';
export default (function (props) {
  var image = props.image,
      preloader = props.preloader,
      onActionStart = props.onActionStart,
      onActionEnd = props.onActionEnd;

  var _useState = useState(preloader ? false : true),
      _useState2 = _slicedToArray(_useState, 2),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  console.log('loaded', loaded);
  console.log('preloader', preloader);
  var transitions = useTransition(loaded, null, {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    }
  });

  var _useSpring = useSpring(function () {
    return {
      xys: [0, 0, 1],
      config: {
        mass: 1,
        tension: 500,
        friction: 24
      }
    };
  }),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      xys = _useSpring2[0].xys,
      setStyle = _useSpring2[1];

  var pos = useRef();
  var scale = useRef();
  var imageDim = useRef();
  var containerRef = useRef();
  useEffect(function () {
    if (preloader) setLoaded(false);
    var img = new Image();

    img.onload = function () {
      imageDim.current = [img.width, img.height];
      if (preloader) setLoaded(true);
      managePostAction();
    };

    img.src = image;
    pos.current = [0, 0];
    scale.current = 1;
  }, [image]);

  var managePostAction = function managePostAction() {
    if (!containerRef.current) return;
    if (scale.current < 1) scale.current = 1;
    var containerRect = containerRef.current.getBoundingClientRect();
    var imgScale = containerRect.height / containerRect.width > imageDim.current[1] / imageDim.current[0] ? containerRect.width / imageDim.current[0] : containerRect.height / imageDim.current[1];
    var imageScaled = [imageDim.current[0] * imgScale * scale.current, imageDim.current[1] * imgScale * scale.current];
    var posLimit = [imageScaled[0] > containerRect.width ? Math.floor((imageScaled[0] - containerRect.width) / 2 / scale.current) : 0, imageScaled[1] > containerRect.height ? Math.floor((imageScaled[1] - containerRect.height) / 2 / scale.current) : 0];
    pos.current = [Math.abs(pos.current[0]) > posLimit[0] ? posLimit[0] * (pos.current[0] / Math.abs(pos.current[0])) : pos.current[0], Math.abs(pos.current[1]) > posLimit[1] ? posLimit[1] * (pos.current[1] / Math.abs(pos.current[1])) : pos.current[1]]; // set Style

    setStyle({
      xys: [].concat(_toConsumableArray(pos.current), [scale.current])
    });
  };

  var handleDragStart = useCallback(function (e) {
    document.addEventListener('mousemove', handleDrag);
    document.addEventListener('mouseup', handleDragEnd);
    if (onActionStart) onActionStart({
      type: 'drag',
      touch: false
    });
    return false;
  }, []);
  var handleDrag = useCallback(function (e) {
    pos.current = [pos.current[0] + e.movementX / scale.current, pos.current[1] + e.movementY / scale.current];
    setStyle({
      xys: [].concat(_toConsumableArray(pos.current), [scale.current])
    });
    return false;
  }, []);
  var handleDragEnd = useCallback(function (e) {
    document.removeEventListener('mousemove', handleDrag);
    document.removeEventListener('mouseup', handleDragEnd);
    managePostAction();
    if (onActionEnd) onActionEnd({
      type: 'drag',
      touch: false
    });
    return false;
  }, []);
  var wheelTimeout = useRef();
  var handleWheel = useCallback(function (e) {
    var delta = e.deltaY || e.deltaX;
    if (!delta) return;
    scale.current = Math.min(Math.max(scale.current + delta / Math.abs(delta) * 0.1, 1), 10);
    managePostAction();

    if (!wheelTimeout.current) {
      if (onActionStart) onActionStart({
        type: 'zoom',
        touch: false
      });
      wheelTimeout.current = setTimeout(function () {
        if (onActionEnd) onActionEnd({
          type: 'zoom',
          touch: false
        });
      }, 300);
    } else {
      clearTimeout(wheelTimeout.current);
      wheelTimeout.current = setTimeout(function () {
        if (onActionEnd) onActionEnd({
          type: 'zoom',
          touch: false
        });
      }, 300);
    }

    return false;
  }, []);
  var lastPos = useRef();
  var lastRadius = useRef();
  var handleTouchStart = useCallback(function (e) {
    lastPos.current = [e.touches[0].screenX, e.touches[0].screenY];
    if (e.touches.length > 1) lastRadius.current = {
      touch: Math.sqrt(Math.pow(e.touches[0].screenX - e.touches[1].screenX, 2) + Math.pow(e.touches[0].screenY - e.touches[1].screenY, 2)),
      scale: scale.current
    };
    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchend', handleTouchEnd);
    if (onActionStart && e.touches.length > 1) onActionStart({
      type: 'zoom',
      touch: true
    });
    if (onActionStart && e.touches.length === 1) onActionStart({
      type: 'drag',
      touch: true
    });
    return false;
  }, []);
  var handleTouchMove = useCallback(function (e) {
    if (e.touches.length > 1) {
      var radius = Math.sqrt(Math.pow(e.touches[0].screenX - e.touches[1].screenX, 2) + Math.pow(e.touches[0].screenY - e.touches[1].screenY, 2));
      var deltaRad = lastRadius.current.scale * (radius / lastRadius.current.touch);
      scale.current = Math.min(Math.max(deltaRad, 0.8), 10);
      setStyle({
        xys: [].concat(_toConsumableArray(pos.current), [scale.current])
      });
    } else {
      pos.current = [pos.current[0] + (e.touches[0].screenX - lastPos.current[0]) / scale.current, pos.current[1] + (e.touches[0].screenY - lastPos.current[1]) / scale.current];
      lastPos.current = [e.touches[0].screenX, e.touches[0].screenY];
      setStyle({
        xys: [].concat(_toConsumableArray(pos.current), [scale.current])
      });
    }

    return false;
  }, []);
  var handleTouchEnd = useCallback(function (e) {
    document.removeEventListener('touchmove', handleTouchMove);
    document.removeEventListener('touchend', handleTouchEnd);
    managePostAction();
    if (onActionEnd && e.touches.length > 1) onActionEnd({
      type: 'zoom',
      touch: true
    });
    if (onActionEnd && e.touches.length === 1) onActionEnd({
      type: 'drag',
      touch: true
    });
    return false;
  }, []);
  return React.createElement("div", {
    ref: containerRef,
    onWheel: handleWheel,
    onMouseDown: handleDragStart,
    onTouchStart: handleTouchStart,
    style: {
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      position: 'relative',
      userSelect: 'none'
    }
  }, preloader && !loaded ? preloader : transitions.map(function (_ref) {
    var item = _ref.item,
        key = _ref.key,
        props = _ref.props;
    return item && React.createElement(animated.img, {
      key: key,
      style: _objectSpread({
        height: '100%',
        width: '100%',
        objectFit: 'contain',
        objectPosition: 'center center',
        userSelect: 'none'
      }, props, {
        transform: xys.interpolate(function (x, y, s) {
          return "scale3d(".concat(s, ",").concat(s, ",1) translate3d(").concat(x, "px, ").concat(y, "px, 0px)");
        })
      }),
      draggable: "false",
      src: image
    });
  }));
});